<template lang="pug">
extends ../dynamic-filter-template

block item
    template(#product_tag.tag_id="props")
        span(:class="props.value.bold ? 'font-weight-bold' : null")
            | {{ props.value.display_name }}
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import tagMixin from '@js/franchise_component/item/tag-mixin';
import profitMixin from '@js/franchise_component/report/profit/profit-mixin';

export default {
    extends: dynamicFilterBase,

    mixins: [tagMixin, profitMixin],

    data() {
        let that = this;

        return {
            preSelectOperator: true,

            returnOperatorValueList: true,

            externalRemotes: {
                salesCategory(query) {
                    return that.getTagListIfNecessary({ query }).then(data => {
                        return data.map(d => ({
                            id: d.id,
                            display_name: d.name,
                            bold: d.parent_id == null,
                        }));
                    });
                },
                promotions(query) {
                    return that
                        .getPromotionListIfNecessary({ query })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.id.toString(),
                            }));
                        });
                },
                reportTypes(query) {
                    return that.getReportType({ query });
                },
            },

            noSelectAllCheckbox: ['Promotion ID', 'Category', 'Type'],
        };
    },

    computed: {
        ...mapGetters('profit', ['filters', 'searchMeta']),

        loading() {
            return this.onLoading('get-profit-meta');
        },
    },

    created() {
        this.getSearchMetaIfNecessary();
        this.getTagListIfNecessary();
        this.getPromotionListIfNecessary();
        this.getReportType();
    },

    methods: {
        ...mapActions('profit', ['getSearchMetaIfNecessary', 'getReportType']),

        ...mapActions('tag', ['getTagListIfNecessary']),

        ...mapMutations('profit', ['setFilters']),

        ...mapActions('receiptPromotion', ['getPromotionListIfNecessary']),
    },
};
</script>
